import { render, staticRenderFns } from "./InformeRiesgos.vue?vue&type=template&id=06d8d695"
import script from "./InformeRiesgos.vue?vue&type=script&lang=js"
export * from "./InformeRiesgos.vue?vue&type=script&lang=js"
import style0 from "./InformeRiesgos.vue?vue&type=style&index=0&id=06d8d695&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports